/*jshint esversion: 6 */
// var domainUrl = 'http://localhost';
// var portt = '8001';
// var basicUrl = domainUrl + ":" + portt;
var domainUrl = process.env.REACT_APP_API_URL;
var basicUrl = domainUrl;
var apiRoute = basicUrl + '/api';
var secureRoute = apiRoute + '/secure';
var adminRoute = secureRoute + '/admin';

var apiRouteNames = {
    apiRoute : apiRoute,
    secureRoute : secureRoute,
    adminRoute : adminRoute,
    templateRoute: apiRoute + '/templates/', 
    pageRoute : apiRoute + '/pages/',
    paragraphRoute : apiRoute + '/paragraphs/',
    manusRoute : apiRoute + '/manus/'
};


export default apiRouteNames;


// WEBPACK FOOTER //
// ./src/API_routes/routeFuncs.js